import { Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const ESimInfoSection = styled.section`
    border-bottom: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray200')};
    padding: ${getPurpurSpacing('600')} 0;
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('200')};
`;

export const ESimInfoSectionTitle = styled(Heading)`
    margin-bottom: ${getPurpurSpacing('100')};
`;
